// extracted by mini-css-extract-plugin
export default {"containerOuter":"cKL0qOKif","testimonialsContainer":"cMkJYosR2","container":"cscTGNUIJ","innerContainer":"cPCLfYJWw","subHeading":"cGZKaar_p","slickSlider":"cb9ybdmaI"};